import { useEffect } from 'react';

import { getLocation } from '@change-corgi/core/window';

import type { AppOptions } from 'src/app/types';

type LoadEventProps = {
	ssr: boolean;
	pathname: string;
	route_id?: string;
	error: boolean;
	error_id?: string;
	bundling_target?: string;
};

export function useWebappTrackLoad({ utilities, ssrContext, errorId }: AppOptions): void {
	useEffect(() => {
		void utilities.tracker.track<LoadEventProps>('webapp_load', {
			ssr: !!ssrContext,
			pathname: getLocation().pathname,
			route_id: ssrContext?.route?.id,
			error: !!errorId,
			error_id: errorId,
			bundling_target: process.env.BUNDLING_TARGET,
		});
	}, [utilities, ssrContext, errorId]);
}
